// ANCHOR Base
import { StatefulPanel } from 'baseui/accordion';

// ANCHOR Models
import { CourseModulePaymentPanelData } from '@lyon/scoped-models/course-payment/CourseModulePaymentPanelData';

// ANCHOR Results
import { ICourseModuleResult } from '@lyon/utils/api/results/course-module';

// ANCHOR Components
import { LyonCourseOutlinePanelHeader } from './LyonCourseOutlinePanelHeader';
import { LyonCourseOutlinePanelBody } from './LyonCourseOutlinePanelBody';

// ANCHOR Styles
import { PANEL } from './styles';

const PANEL_HEADER = <LyonCourseOutlinePanelHeader />;

interface IProps {
  data: ICourseModuleResult;
}

export function LyonCourseOutlinePanel({ data }: IProps) {
  return (
    <CourseModulePaymentPanelData.Provider data={data}>
      <StatefulPanel title={PANEL_HEADER} overrides={PANEL}>
        <LyonCourseOutlinePanelBody />
      </StatefulPanel>
    </CourseModulePaymentPanelData.Provider>
  );
}
